import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const Wrapper = styled(Box)<{ type?: string; noBg?: boolean; borderbottom?: string; bg?: string }>`
  border-bottom: ${({ noBg, borderbottom }) =>
    borderbottom && borderbottom === 'true'
      ? `1px solid ${theme.colors.borderLow}`
      : noBg
      ? 'none'
      : `1px solid ${theme.colors.borderLow}`};
  background: ${({ bg }) => (bg ? `${bg}` : 'transparent')};
  height: 100px;
  padding-left: ${theme.spacing.medium}px;
  padding-right: ${theme.spacing.medium}px;
  position: static;
  top: 0;
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;

  ${({ type }) =>
    type === 'dashboard' &&
    `
    left: 72px;
    height: 80px;

    html[data-theme='light'] & {
      background: ${theme.colors.backgroundLight};
      border-bottom: 1px solid ${theme.colors.strokePrimary};
    }
  `};
`
export const HeaderBreadcrumbsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xSmall}px;

  .link-block {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;
  }

  .text {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxLarge};
    font-weight: ${theme.typography.fontWeight.normal};
    color: ${theme.colors.foreground};
    font-style: normal;
    line-height: 28px;
    text-transform: capitalize;
  }

  .link {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxLarge};
    font-weight: ${theme.typography.fontWeight.normal};
    color: ${theme.colors.foreground};
    font-style: normal;
    line-height: 28px;
    text-transform: capitalize;
    text-decoration: none;

    &:hover {
      color: ${theme.colors.foreground};
    }
  }
`
